export default {
	inject: ['$validator'],
	props: {
		parent: {
			value: Object,
			default: undefined
		},
		authToken: {
			value: String
		},
		wrapperClass: {
			value: String
		},
		inputClass: {
			value: String
		},
		collectCardHolderName: {
			value: Boolean
		},
		collectPostalCode: {
			value: Boolean
		},
		enableDataCollector: {
			value: Boolean
		},
		plan: {
			value: Object,
			default: undefined
		}
	},
	created() {
		if (this.parent === undefined) {
			this.parent = this.$parent;
		}
		this.collectPostalCode = false;
		this.createBT();

		this.parent.$on('tokenize', () => {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.tokenizeHF();
				}
			});
		});
		this.parent.$on('teardown', () => {
			this.teardownHF();
		});
	},
	data() {
		return {
			errorMessage: '',
			clientInstance: '',
			hostedFieldsInstance: '',
			threeDSecureInstance: '',
			dataCollectorPayload: '',
			credential: {
				cardholderName: '',
				cardNumber: '',
				expDate: '',
				ccv: '',
				postalCode: 0
			}
		};
	},
	methods: {
		createBT() {
			const client = require('braintree-web/client');
			client.create(
				{
					authorization: this.authToken
				},
				(clientErr, clientInstance) => {
					if (clientErr) {
						this.errorMessage = 'There was an error setting up the client instance. Message: ' + clientErr.message;
						this.$emit('bthferror', this.errorMessage);
						return;
					} else {
						this.clientInstance = clientInstance;
						this.createHF();
						this.create3DSecure();

						if (this.enableDataCollector) {
							this.dataCollectorCreate();
						}
					}
				}
			);
		},
		createHF() {
			const hostedFields = require('braintree-web/hosted-fields');
			hostedFields.create(
				{
					client: this.clientInstance,
					styles: {
						input: {
							'font-family': 'sans-serif',
							'font-size': '16px',
							'font-weight': '400',
							'line-height': '20px',
							padding: '8px 0px'
						},
						'input.invalid': {
							color: 'red'
						},
						'input.valid': {
							color: 'green'
						}
					},
					fields: {
						number: {
							selector: '#number'
						},
						cvv: {
							selector: '#ccv'
						},
						expirationDate: {
							selector: '#expdate'
						}
					}
				},
				(hostedFieldsErr, hostedFieldsInstance) => {
					if (hostedFieldsErr) {
						// Handle error in Hosted Fields creation
						this.errorMessage = 'There was an error setting up the hosted fields! Message: ' + hostedFieldsErr.message;
						this.$emit('bthferror', this.errorMessage);
						return;
					} else {
						this.hostedFieldsInstance = hostedFieldsInstance;
					}

					hostedFieldsInstance.on('focus', function(event) {
						var field = event.fields[event.emittedBy];
						field.container.parentElement.firstChild.classList.add('v-label--active');
						field.container.parentElement.parentElement.parentElement.parentElement.classList.add('v-input--is-label-active');
					});

					hostedFieldsInstance.on('blur', function(event) {
						var field = event.fields[event.emittedBy];

						if (field.isEmpty) {
							field.container.parentElement.parentElement.parentElement.parentElement.classList.remove('v-input--is-label-active');
						}
						if (!field.container.parentElement.parentElement.parentElement.parentElement.classList.contains('v-input--is-label-active')) {
							field.container.parentElement.firstChild.classList.remove('v-label--active');
						}
					});
				}
			);
		},
		create3DSecure() {
			const threeDSecure = require('braintree-web/three-d-secure');
			threeDSecure.create(
				{
					client: this.clientInstance,
					version: 2
				},
				(threeDSecureErr, threeDSecureInstance) => {
					if (threeDSecureErr) {
						// Handle error in ThreeDSecure creation
						this.errorMessage = 'There was an error setting up the threeDSecury! Message: ' + threeDSecureErr.message;
						this.$emit('bthferror', this.errorMessage);
						return;
					} else {
						this.$emit('bthfready');
						this.threeDSecureInstance = threeDSecureInstance;
					}
				}
			);
		},
		tokenizeHF() {
			const vue = this;
			const additionalFields = {
				cardholderName: ''
			};
			if (this.collectCardHolderName) {
				additionalFields.cardholderName = this.credential.cardholderName;
			}
			if (this.collectPostalCode) {
				additionalFields.billingAddress.postalCode = this.credential.postalCode;
			}
			this.hostedFieldsInstance.tokenize(additionalFields, (tokenizeErr, payload) => {
				if (tokenizeErr) {
					this.errorMessage = 'There was an error tokenizing! Message: ' + tokenizeErr.message;
					this.$emit('bthferror', this.errorMessage);
					return;
				}

				this.threeDSecureInstance.verifyCard(
					{
						amount: vue.plan.priceTotal,
						nonce: payload.nonce,
						onLookupComplete: function(data, next) {
							next();
						}
					},
					function(err, payload) {
						if (err) {
							this.errorMessage = 'There was an error tokenizing! Message: ' + err.message;
							this.$emit('bthferror', this.errorMessage);
							return;
						}
						vue.$emit('bthfpayload', payload);
					}
				);
			});
		},
		teardownHF() {
			if (this.hostedFieldsInstance !== '') {
				this.hostedFieldsInstance.teardown(teardownErr => {
					if (teardownErr) {
						this.errorMessage = 'There was an error tearing it down! Message: ' + teardownErr.message;
						this.$emit('bthferror', this.errorMessage);
					} else {
						this.hostedFieldsInstance = '';
					}
				});
			}
			if (this.threeDSecureInstance !== '') {
				this.threeDSecureInstance.teardown(teardownErr => {
					if (teardownErr) {
						this.errorMessage = 'There was an error tearing it down! Message: ' + teardownErr.message;
						this.$emit('bthferror', this.errorMessage);
					} else {
						this.threeDSecureInstance = '';
					}
				});
			}
		},
		dataCollectorCreate() {
			const dataCollector = require('braintree-web/data-collector');
			dataCollector.create(
				{
					client: this.clientInstance,
					kount: true
				},
				(dataCollectorErr, dataCollectorInstance) => {
					if (dataCollectorErr) {
						this.errorMessage = 'There was an error setting up the data collector! Message: ' + dataCollectorErr.message;
						this.$emit('bthferror', this.dataCollectorErr);
						return;
					}

					this.$emit('device.data.payload', dataCollectorInstance.deviceData);
					this.dataCollectorPayload = dataCollectorInstance;
				}
			);
		}
	}
};



// WEBPACK FOOTER //
// ./app/components/hosted-fields/script.js